import { FC } from "react";
import { Skeleton, Stack } from "@mui/material";

export const CommitmentsOverviewContentLoading: FC = () => {
  return (
    <Stack spacing={3} p={2}>
      <Stack
        direction="row"
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        <Skeleton
          variant="circular"
          width={100}
          height={100}
          sx={{ minWidth: 100 }}
        />
        <Skeleton variant="rectangular" width={160} height={60} />
        <Skeleton variant="rectangular" width={160} height={60} />
      </Stack>
      <Stack direction="row" spacing={4}>
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width={120} height={20} />
      </Stack>
      <Stack direction="row" spacing={4}>
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width={120} height={20} />
      </Stack>
      <Stack direction="row" spacing={4}>
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width={120} height={20} />
      </Stack>
      <Stack direction="row" spacing={4}>
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width={120} height={20} />
      </Stack>
    </Stack>
  );
};
